import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Models } from 'models/core';
import { ErrorService } from 'services/error-service';
import { GeneralOfferTypeService } from 'services/general-offer-type-service';
import { ToastService } from 'services/toast-service';

@autoinject
export class GeneralOfferTypeNew {
  private generalOfferType: Models.GeneralOfferType = new Models.GeneralOfferType();

  private constructor(
    private errorService: ErrorService,
    private eventAggregator: EventAggregator,
    private router: Router,
    private toastService: ToastService,
    private generalOfferTypeService: GeneralOfferTypeService
  ) {}

  private createGeneralOfferType() {
    this.generalOfferTypeService
      .post(this.generalOfferType)
      .then((res) => {
        this.eventAggregator.publish('generalOfferTypeListReset', 1);
        this.toastService.showSuccess('generalOfferType.created');
        this.router.navigateToRoute('general-offer-type-detail', { Id: res.Id });
      })
      .catch((err) => this.errorService.handleError(err));
  }
}
